;
define("quickorder_accesspoints_headerlink.tpl", function(){});

